import { render, staticRenderFns } from "./Acknowledgement.vue?vue&type=template&id=155135c0&scoped=true&"
import script from "./Acknowledgement.vue?vue&type=script&lang=js&"
export * from "./Acknowledgement.vue?vue&type=script&lang=js&"
import style0 from "./Acknowledgement.vue?vue&type=style&index=0&id=155135c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155135c0",
  null
  
)

export default component.exports